// MO4.1M
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUpIcon from '@wix/da-ds/pkg/Icons/ArrowUp';
import Flex from '@wix/da-ds/pkg/Flex';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { hashString } from '../../../utils/hash';
import MediaService, { fallbackToLargestFile } from '../../../utils/DeviationMediaService';
import TierStatisticsBar from '../../Helper/StatisticsBar/TierStatisticsBar';
import Benefits from '../Benefits';
import { formatPrice } from '../utils';
import s from './TierProductCardDumbMobile.scss';
const THUMB_WIDTH = 360;
const THUMB_HEIGHT = 140;
const TierProductCardDumbMobile = ({ coverImage, title, tierState, stats, ctaButton, description, price = '', benefits = [], hasDiscord, info, withExpandButton, coverAreaExtrasLeft, coverAreaExtrasRight, isHighlighted, className, onClick, onToggleCollapsed, isCollapsed: isCollapsedProp, innerRef })=>{
    const { t } = useTranslation();
    const [isCollapsedState, setIsCollapsed] = useState(false);
    const isControlled = isCollapsedProp !== undefined;
    const isCollapsed = isControlled ? isCollapsedProp : isCollapsedState;
    const hasBenefits = benefits.length > 0 || hasDiscord;
    const isCollapsible = withExpandButton && hasBenefits;
    const benefitsHash = hashString(`benefits.${benefits.join('|')}`);
    const toggleCollapsed = useCallback(()=>{
        if (isControlled) {
            onToggleCollapsed && onToggleCollapsed(!isCollapsed);
        } else {
            setIsCollapsed(!isCollapsed);
        }
    }, [
        onToggleCollapsed,
        isControlled,
        isCollapsed
    ]);
    const preview = coverImage && MediaService.getSmallestThumbThatFullyCovers(coverImage, THUMB_WIDTH, THUMB_HEIGHT, fallbackToLargestFile, {
        allowPreview: true,
        allowFullview: false
    });
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], isHighlighted && s['root-highlight'], onClick && s['clickable-root'], className),
        direction: "column",
        onClick: onClick,
        innerRef: innerRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['cover-wrapper']
    }, coverAreaExtrasLeft && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-area-extras-left']
    }, coverAreaExtrasLeft), coverAreaExtrasRight && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-area-extras-right']
    }, coverAreaExtrasRight), preview ? /*#__PURE__*/ React.createElement("div", {
        className: s['cover'],
        style: {
            width: '100%',
            height: THUMB_HEIGHT,
            backgroundImage: `url('${preview.src}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'center',
            backgroundPositionY: 'center',
            backgroundSize: 'cover'
        }
    }) : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['cover'], s['placeholder-cover']),
        style: {
            width: '100%',
            height: THUMB_HEIGHT
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['cover-overlay']
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement(TierStatisticsBar, {
        className: s['stats'],
        stats: stats
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['card-body']
    }, price && /*#__PURE__*/ React.createElement("div", {
        className: s['price-block']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formatPrice(price)), /*#__PURE__*/ React.createElement("span", {
        className: s['price-period']
    }, "/", t('deviationview.tierCard.pricePeriod.month'))), ctaButton && /*#__PURE__*/ React.createElement("div", {
        className: s['cta-button']
    }, ctaButton), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['collapsible'], isCollapsed && s['collapsed'])
    }, description && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['description'], !hasBenefits && s['no-benefits'])
    }, description), hasBenefits && /*#__PURE__*/ React.createElement(Benefits, {
        key: benefitsHash,
        benefits: benefits,
        hasDiscord: hasDiscord
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['card-footer']
    }, info && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['collapsible'], isCollapsed && s['collapsed'])
    }, /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Flex, {
        className: s['info-block'],
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        size: IconSize.SMALLER,
        className: s['info-icon'],
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, info))), isCollapsible && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: toggleCollapsed,
        className: s['toggle-button']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['toggle-button-label']
    }, isCollapsed ? t('deviationview.tierCard.showMore') : t('deviationview.tierCard.showLess')), isCollapsed ? /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }) : /*#__PURE__*/ React.createElement(ArrowUpIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })))));
};
TierProductCardDumbMobile.displayName = 'TierProductCardDumbMobile';
export default TierProductCardDumbMobile;
